import { gql } from '@common/hooks';
import { DetailItemAttachments } from '@onboarding/graphql/fragments';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

const UpdateNurseAssessmentMutation = gql`
  mutation UpdateNurseAssessmentMutation(
    $id: ID!
    $input: UpdateNurseAssessmentInput!
    $files: [FileUploadInput!]!
    $issuerId: ID!
  ) {
    updateNurseAssessment(
      id: $id
      input: $input
      files: $files
      issuerId: $issuerId
    ) {
      nurseAssessment {
        id
        completedOn
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

const CreateNurseAssessmentMutation = gql`
  mutation CreateNurseAssessmentMutation(
    $worksProfileId: ID!
    $worksListItemId: ID!
    $assessmentId: ID!
    $input: CreateNurseAssessmentInput!
    $files: [FileUploadInput!]!
    $issuerId: ID!
  ) {
    createNurseAssessment(
      worksProfileId: $worksProfileId
      worksListItemId: $worksListItemId
      assessmentId: $assessmentId
      input: $input
      files: $files
      issuerId: $issuerId
    ) {
      nurseAssessment {
        id
        assessment {
          id
          name
        }
        completedOn
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

export { CreateNurseAssessmentMutation, UpdateNurseAssessmentMutation };
